import { inject } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { ActivatedRouteSnapshot, ResolveFn, Routes } from '@angular/router';
import {
  Observable, of
} from 'rxjs';
import {
  filter, map
} from 'rxjs/operators';
import {
  PrescriptionRx, IPrescriptionRx
} from 'app/shared/model/prescription-rx.model';
import PrescriptionRxService from './prescription-rx.service';
import PrescriptionRxComponent from './prescription-rx.component';
import ResolvePagingParams from '../resolve-paging-params.service';

export const PrescriptionRxResolve: ResolveFn<IPrescriptionRx> = (route: ActivatedRouteSnapshot): Observable<IPrescriptionRx> => {
  const { id } = route.params;
  if (id) {
    return inject(PrescriptionRxService).find(id).pipe(
      filter((response: HttpResponse<PrescriptionRx>) => response.ok),
      map((prescription: HttpResponse<PrescriptionRx>) => prescription.body)
    );
  }
  return of(new PrescriptionRx());
};

export const prescriptionRoute: Routes = [
  {
    path: '',
    redirectTo: 'refill/search',
    pathMatch: 'full'
  },
  {
    path: '',
    redirectTo: 'refill/list',
    pathMatch: 'full'
  },
  {
    path: 'refill/:step',
    component: PrescriptionRxComponent,
    resolve: {
      prescription: PrescriptionRxResolve,
      pagingParams: ResolvePagingParams
    },
    data: {
      authorities: ['ROLE_USER'],
      pageTitle: 'bjcrxApp.prescription.home.title'
    }
  }
];
